export default __webpack_public_path__ + "static/media/cheer_btn-normal.1ee15c77.svg";